import { render } from "./sclfdzManager.vue?vue&type=template&id=0684fe80"
import script from "./sclfdzManager.vue?vue&type=script&lang=js"
export * from "./sclfdzManager.vue?vue&type=script&lang=js"

import "./sclfdzManager.vue?vue&type=style&index=0&id=0684fe80&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__